import styles from './ExtranetContacts.module.scss';
import { EMAIL_TYPE_COLUMNS } from './columns';

export const ColumnsHeader = () => (
  <div className={styles.header}>
    <div className={styles.headerSpacer} />
    {EMAIL_TYPE_COLUMNS.map((column) => (
      <div key={column.key} className={styles.columnHeader}>
        {column.label}
      </div>
    ))}
  </div>
);
